import { render, staticRenderFns } from "./PeriodColumnTemplate.vue?vue&type=template&id=23c37fe6"
import script from "./PeriodColumnTemplate.vue?vue&type=script&lang=js"
export * from "./PeriodColumnTemplate.vue?vue&type=script&lang=js"
import style0 from "./PeriodColumnTemplate.vue?vue&type=style&index=0&id=23c37fe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports